import { render, staticRenderFns } from "./ViewKiddiesAccount.vue?vue&type=template&id=61e80b72&scoped=true"
import script from "./ViewKiddiesAccount.vue?vue&type=script&lang=js"
export * from "./ViewKiddiesAccount.vue?vue&type=script&lang=js"
import style0 from "./ViewKiddiesAccount.vue?vue&type=style&index=0&id=61e80b72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e80b72",
  null
  
)

export default component.exports